import { PrismicRichText } from '@prismicio/react';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fieldHasContent, transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

import { FAQSection } from '@/src/components/FrequentlyAskedQuestions';
import {
  OverviewLabel,
  OverviewTitleComponent,
  OverviewDescriptionComponent,
} from '@/src/components/OverviewSection';
import { VideoPlayer } from '@/src/views/Services/GlobalPayroll/slices/BestPracticesSlice';

const Section = styled.section`
  ${fluidProp('padding-top', '100px', '150px')}
  ${fluidProp('margin-bottom', '-140px', '-440px')}
  background-color: #f4f8fe;

  ${OverviewTitleComponent} {
    max-width: unset;
  }

  ${OverviewDescriptionComponent} {
    color: var(--colors-bayoux);
    text-align: center;
  }
`;

const FAQSectionWrapper = styled(FAQSection)`
  background-image: none;
  background-color: var(--colors-blank);
  ${fluidProp('padding-top', '150px', '500px')};
`;

export function FAQSlice({ slice }) {
  const { primary, context } = transformProperties(slice);
  const { title } = primary;
  const { fields: sections } = slice;

  const { dataContent } = context;

  const videoHeader = dataContent.body.find(({ sliceType }) => sliceType === 'payroll_video_slice');
  const { videoLabel, videoTitle, videoDescription } = videoHeader?.primary;

  return (
    <>
      <Section>
        <ContentContainer>
          {fieldHasContent(videoLabel) && (
            <OverviewLabel>
              <small>{videoLabel}</small>
            </OverviewLabel>
          )}
          {fieldHasContent(videoTitle) && (
            <OverviewTitleComponent>
              <PrismicRichText field={videoTitle} />
            </OverviewTitleComponent>
          )}
          {fieldHasContent(videoDescription) && (
            <OverviewDescriptionComponent>
              <PrismicRichText field={videoDescription} />
            </OverviewDescriptionComponent>
          )}
          <VideoPlayer />
        </ContentContainer>
      </Section>
      <FAQSectionWrapper title={title} frequentlyAskedQuestions={sections} />
    </>
  );
}
